<div class="keyword-top-box">

<!--
  <div class="keyword-rate-box"
       *ngIf="showLevel && word.level > 0">
    <i class="ic ic-rate"
       [class.four]="word.level === 4"
       *ngFor="let i of Array(word.level).fill(1)"></i>
  </div>
-->

  <app-word-disp [word]="word"
                 [showLevel]="showLevel"
                 [select]="select"></app-word-disp>

  <div class="voice-box">
    <app-word-play-btn [word]="word"></app-word-play-btn>
    <app-word-record-btn [word]="word"></app-word-record-btn>
  </div>

  <div class="help-btn-box"
       *ngIf="select">
    <button type="button"
            class="help-btn"
            (click)="openWordHelp.emit()">도움말</button>
  </div>

</div>

<div class="keyword-bottom-box"
     *ngIf="!select">
  <div class="txt-box" [innerHTML]="briefMeaning | resize | keepHtml"></div>
</div>
